import Swiper, { Autoplay, EffectFade, Pagination } from 'swiper'

const els = document.querySelectorAll('.element-mediaslider')

export default {
  can: () => els.length,
  run: () => {
    els.forEach((el) => {
      const container = el.querySelector('.swiper')
      const numSlides = el.querySelectorAll('.swiper-slide').length

      if (numSlides > 1) {
        new Swiper(container, {
          modules: [Autoplay, EffectFade, Pagination],
          autoplay: {
            delay: 4000,
          },
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          speed: 750,
          pagination: {
            el: el.querySelector('.slider-pagination'),
            clickable: true,
          },
        })
      }
    })
  },
}
